
import { useAdZone } from "@/context/AdZonesContext";
import { AdZoneDisplay } from "./AdZoneDisplay";
import { AdZone, DEFAULT_AD_ZONES } from "@/types/adZones";
import { normalizeFooterCards, FOOTER_GUIDES_SECTION_TITLE } from "@/utils/adZoneFooterUtils";

const toFallbackZone = (key: "footer"): AdZone => ({
  id: "fallback",
  zone_key: key,
  title: FOOTER_GUIDES_SECTION_TITLE,
  description: DEFAULT_AD_ZONES[key].description,
  image_url: DEFAULT_AD_ZONES[key].image_url,
  cta_label: DEFAULT_AD_ZONES[key].cta_label || null,
  cta_url: DEFAULT_AD_ZONES[key].cta_url || null,
  cards: normalizeFooterCards(DEFAULT_AD_ZONES[key].cards),
  is_active: DEFAULT_AD_ZONES[key].is_active,
  updated_at: new Date().toISOString(),
  updated_by: null,
});

export const AdZoneBanner = () => {
  const { zone } = useAdZone("banner");
  return <AdZoneDisplay zone={zone} variant="banner" />;
};

export const AdZoneSidebar = ({ className }: { className?: string }) => {
  const { zone } = useAdZone("sidebar");
  return <AdZoneDisplay zone={zone} variant="sidebar" className={className} />;
};

export const AdZoneFooter = () => {
  const { zone, loading } = useAdZone("footer");

  if (loading) {
    return null;
  }

  const displayZone = zone ?? toFallbackZone("footer");
  return <AdZoneDisplay zone={displayZone} variant="footer" />;
};
